import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import stylesheet from './Typography.module.css';

function Typography(props) {
  let { element, typeClasses, className, children, ...otherProps } = props;
  let El = element;
  return (
    <El className={cs(typeClasses, { [className]: className })} {...otherProps}>
      {children}
    </El>
  );
}
Typography.propTypes = {
  element: PropTypes.string,
  typeClasses: PropTypes.string,
};
Typography.defaultProps = {
  element: 'span',
  typeClasses: '',
};

function buildComponent(element, typeClasses) {
  let newComp = function(props) {
    return (
      <Typography element={element} typeClasses={typeClasses} {...props}>
        {props.children}
      </Typography>
    );
  };

  newComp.displayName = `${element}(Typography)`;

  return newComp;
}

export const TextSmall = buildComponent('span', cs(stylesheet.textSmall, 'text'));
export const Text = buildComponent('span', cs(stylesheet.text, 'text'));
export const TextLarge = buildComponent('span', cs(stylesheet.textLarge, 'text'));

export const PSmall = buildComponent('p', cs(stylesheet.textSmall, 'text'));
export const P = buildComponent('p', cs(stylesheet.text, 'text'));
export const PLarge = buildComponent('p', cs(stylesheet.textLarge, 'text'));

export const H1 = buildComponent('h1', cs(stylesheet.h1, 'heading'));
export const H2 = buildComponent('h2', cs(stylesheet.h2, 'heading'));
export const H3 = buildComponent('h3', cs(stylesheet.h3, 'heading'));
export const H4 = buildComponent('h4', cs(stylesheet.h4, 'heading'));
export const H5 = buildComponent('h5', cs(stylesheet.h5, 'heading'));
export const H6 = buildComponent('h6', cs(stylesheet.h6, 'heading'));

export const Light = buildComponent('span', stylesheet.light);
export const Medium = buildComponent('span', stylesheet.medium);
export const Bold = buildComponent('span', stylesheet.bold);
export const Black = buildComponent('span', stylesheet.black);



// WEBPACK FOOTER //
// ./src/components/Typography/Typography.js